import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const listData: Array<ItemVM> = [
  {
    id: '',
    value: 'Nessuno',
  },
  {
    id: '164',
    value: 'Dichiarazione di morte',
  },
  {
    id: '132',
    value: 'Dichiarazione di matrimonio',
  },
  {
    id: '139-bis',
    value: 'Dichiarazione di unione civile',
  },
];

interface ListAnnotationProposalsProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
  required?: boolean;
}

const ListAnnotationProposalsComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Proposte di annotazione',
  required,
}: ListAnnotationProposalsProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="list-annotation-proposals-label">{`${label} ${
        required ? '*' : ''
      }`}</InputLabel>
      <PmiSelect
        labelId="list-annotation-proposals-label"
        id="list-annotation-proposals"
        name="list-annotation-proposals"
        value={value}
        label={`${label} ${required ? '*' : ''}`}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {listData?.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListAnnotationProposalsComponent.displayName = 'List Annotation Proposals component';

const ListAnnotationProposals = memo(ListAnnotationProposalsComponent);

export default ListAnnotationProposals as typeof ListAnnotationProposalsComponent;
